<template>
  <div class="badge-button-container" v-if="value > 0">
    <span
      class="badge"
      :style="{
        backgroundImage: `url(${require(`@/assets/icons/star-filled.svg`)})`
      }"
    >
      <span class="badge-number">{{ value }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "Badge",
  props: {
    value: {}
  }
};
</script>

<style scoped>
.badge-button-container {
  position: relative;
}

.badge {
  width: 30px;
  z-index: 1;
  right: calc(50% - 23px);
  color: #fff;
  position: absolute;
  display: block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.badge-number {
  line-height: 30px;
  font-size: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
